var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-links"},[_c('nuxt-link',{staticClass:"terms",attrs:{"to":"/legal-info"}},[_vm._v("\n    Юридическая информация\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }